import * as Icons from 'lucide-react';
import { LogOut } from 'lucide-react';
import { getProfile } from '../../config/activityProfileConfig';
import { useAuth } from '../../contexts/AuthContext';
import useGrandeEcole from '../../stores/useGrandeEcole';

export default function AppSidebar({ collapsed, activeSection, onNavigate }) {
  const { user, logout, isAuthenticated, loading: authLoading } = useAuth();
  const {
    activityProfile,
    layout,
    totalLearners,
    courses,
    cohortes,
    setActivityProfile,
    
    v = {} // vocabulary, si disponible dans le store (sinon fallback)
  } = useGrandeEcole();

  const profile = getProfile(activityProfile);
  const order = layout?.sidebarOrder || [];
  const modules = layout?.modules || {};

  // Récupération du vocabulaire (si le store l'expose, sinon depuis le profil)
  const vocab = v.learners ? v : profile.vocabulary;

  const getIcon = (iconName) => {
    const IconComponent = Icons[iconName];
    return IconComponent ? <IconComponent size={16} /> : <Icons.Circle size={16} />;
  };

  return (
    <nav
      className={`
        border-r border-zinc-800 transition-all duration-200
        ${collapsed ? 'w-0' : 'w-52'}
        overflow-hidden bg-zinc-900/60
        hidden md:block
      `}
    >
      <div className={`p-2 pt-4 ${collapsed ? 'hidden' : 'block'}`}>
        {order.map((sectionId) => {
          const meta = modules[sectionId];
          const label = meta?.label ?? sectionId;
          const iconName = meta?.icon || 'Circle';
          const isActive = activeSection === sectionId;

          return (
            <button
              key={sectionId}
              onClick={() => onNavigate(sectionId)}
              className={`w-full flex items-center gap-2.5 px-3 py-2.5 text-[10px] uppercase tracking-widest transition-colors rounded-sm ${
                isActive
                  ? 'text-orange-400 bg-orange-950/20 border-l-2 border-orange-500'
                  : 'text-zinc-400 hover:text-zinc-200 hover:bg-zinc-800/40'
              }`}
            >
              {getIcon(iconName)}
              <span>{label}</span>
            </button>
          );
        })}

        {/* Stats rapides */}
        <div className="mt-6 pt-4 border-t border-zinc-700 px-3 space-y-2">
          <div className="text-[9px] uppercase tracking-widest text-zinc-500 mb-2">
            Stats Live
          </div>
          <div className="flex justify-between text-[10px]">
            <span className="text-zinc-500">{vocab.learners || 'Apprenants'}</span>
            <span className="text-emerald-400 font-bold">{totalLearners}</span>
          </div>
          <div className="flex justify-between text-[10px]">
            <span className="text-zinc-500">{vocab.courses || 'Parcours'}</span>
            <span className="text-orange-400 font-bold">{courses.length}</span>
          </div>
          <div className="flex justify-between text-[10px]">
            <span className="text-zinc-500">{vocab.cohortes || 'Cohortes'}</span>
            <span className="text-sky-400 font-bold">{cohortes.length}</span>
          </div>          

          {/* Déconnexion */}
          <button
            onClick={() => {
              if (window.confirm('Voulez-vous vraiment vous déconnecter ?')) {
                logout();
                window.location.href = '/auth/login';
              }
            }}
            className="flex items-center gap-2 mt-2 text-[10px] text-red-400/70 hover:text-red-400 transition-colors w-full"
          >
            <LogOut size={12} />
            <span>Déconnexion</span>
          </button>
        </div>

        {/* Info utilisateur */}
        {user && (
          <div className="mt-4 px-3 py-2 bg-zinc-800/50 rounded text-[10px]">
            <div className="text-zinc-500 mb-1">Connecté en tant que</div>
            <div className="text-zinc-300 font-medium truncate">
              {user.nom} {user.prenom}
            </div>
            <div className="text-zinc-500 truncate">{user.email}</div>
          </div>
        )}
      </div>
    </nav>
  );
}